"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerApiEventName = void 0;
var PlayerApiEventName;
(function (PlayerApiEventName) {
    /**
     * Плеер проинициализирован.
     */
    PlayerApiEventName["Ready"] = "Ready";
    /**
     * Скин проинициализирован и готов к использованию.
     * Если в переданном объекте присутствует поле error - произошла ошибка инициализации скина.
     */
    PlayerApiEventName["SkinReady"] = "SkinReady";
    /**
     * Плеер отрисовал poster и кнопку Play поверх (в случае необходимости).
     */
    PlayerApiEventName["PosterReady"] = "PosterReady";
    /**
     * С точки зрения пользователей плеер готов работе.
     */
    PlayerApiEventName["UserReady"] = "UserReady";
    /**
     * Плеер задестроен
     */
    PlayerApiEventName["Destroy"] = "Destroy";
    /**
     * Вызывается при показе первого кадра видео-контента (при инициализации и после setSource)
     */
    PlayerApiEventName["ContentImpression"] = "ContentImpression";
    /**
     * Вызывается при запуске и после setSource в момент, когда плеер освободил
     * критичные сетевые ресурсы. После этого приложение может начать использовать сеть, не замедляя
     * запуск видео.
     */
    PlayerApiEventName["ResourcesIdle"] = "ResourcesIdle";
    /**
     * Вызывается при смене источника видео
     */
    PlayerApiEventName["SourceChange"] = "SourceChange";
    /**
     * Вызывается при смене проигрываемого потока
     */
    PlayerApiEventName["StreamChange"] = "StreamChange";
    /**
     * Вызывается при смене доступных потоков источника видео
     */
    PlayerApiEventName["StreamsWithSupportInfoChange"] = "StreamsWithSupportInfoChange";
    /**
     * Вызывается при смене стадии запуска плеера
     */
    PlayerApiEventName["StartStageChange"] = "StartStageChange";
    /**
     * Вызывается при смене состояния проигрывания
     */
    PlayerApiEventName["PlayingStateChange"] = "PlayingStateChange";
    /**
     * Вызывается при запросе смены состояния проигрывания через внешнее API
     */
    PlayerApiEventName["RequestPlayingState"] = "RequestPlayingState";
    /**
     * Вызывается при смене типа проигрываемого видео
     */
    PlayerApiEventName["VideoTypeChange"] = "VideoTypeChange";
    /**
     * Вызывается при изменении UTC-таймстампа, соответствующего currentTime = 0
     */
    PlayerApiEventName["UtcStartTimeChange"] = "UtcStartTimeChange";
    /**
     * Вызывается при изменении доступного начала области перемотки на таймлайне
     */
    PlayerApiEventName["DVRStartTimeChange"] = "DVRStartTimeChange";
    /**
     * Вызывается при изменении доступной длины области перемотки на таймлайне
     */
    PlayerApiEventName["DVRDurationChange"] = "DVRDurationChange";
    /**
     * Вызывается при изменении текущего времени
     */
    PlayerApiEventName["CurrentTimeChange"] = "CurrentTimeChange";
    /**
     * Вызывается при изменении просмотренного времени текущего стрима
     */
    PlayerApiEventName["WatchedTimeChange"] = "WatchedTimeChange";
    /**
     * Вызывается при изменении задержки кадра прямого эфира относительно серверного времени
     */
    PlayerApiEventName["LiveLatencyChange"] = "LiveLatencyChange";
    /**
     * Вызывается при изменении длительности видео
     */
    PlayerApiEventName["DurationChange"] = "DurationChange";
    /**
     * Вызывается при изменении громкости видео
     */
    PlayerApiEventName["VolumeChange"] = "VolumeChange";
    /**
     * Вызывается при смене состояния мьюта
     */
    PlayerApiEventName["MutedChange"] = "MutedChange";
    /**
     * Вызывается при смене причины изменения громкости
     */
    PlayerApiEventName["VolumeChangeReasonChange"] = "VolumeChangeReasonChange";
    /**
     * Вызывается при смене полноэкранного режима
     */
    PlayerApiEventName["FullscreenStateChange"] = "FullscreenStateChange";
    /**
     * Вызывается при запросе о смене полноэкранного режима
     */
    PlayerApiEventName["RequestFullscreenStateChange"] = "RequestFullscreenStateChange";
    /**
     * Вызывается при режима PictureInPicture
     */
    PlayerApiEventName["PictureInPictureStateChange"] = "PictureInPictureStateChange";
    /**
     * Вызывается при изменении состояния видимости
     */
    PlayerApiEventName["VisibleStateChange"] = "VisibleStateChange";
    /**
     * Вызывается при изменении размеров видео
     */
    PlayerApiEventName["VideoSizeChange"] = "VideoSizeChange";
    /**
     * Вызывается при изменении доступных видео-дорожек
     */
    PlayerApiEventName["VideoTracksChange"] = "VideoTracksChange";
    /**
     * Вызывается при смене текущей видео-дорожки
     */
    PlayerApiEventName["VideoTrackChange"] = "VideoTrackChange";
    /**
     * Вызывается при изменении доступных аудио-дорожек
     */
    PlayerApiEventName["AudioTracksChange"] = "AudioTracksChange";
    /**
     * Вызывается при смене текущей аудио-дорожки
     */
    PlayerApiEventName["AudioTrackChange"] = "AudioTrackChange";
    /**
     * Вызывается при изменении доступных текстовых дорожек
     */
    PlayerApiEventName["TextTracksChange"] = "TextTracksChange";
    /**
     * Вызывается при смене текущией текстовой дорожки
     */
    PlayerApiEventName["TextTrackChange"] = "TextTrackChange";
    /**
     * Вызывается при изменении субтитров
     */
    PlayerApiEventName["SubtitlesChange"] = "SubtitlesChange";
    /**
     * Вызывается при изменении текущей фатальной ошибки
     */
    PlayerApiEventName["ErrorChange"] = "ErrorChange";
    /**
     * Вызывается при изменении диапазона скоростей воспроизведения видео
     */
    PlayerApiEventName["PlaybackRateRangeChange"] = "PlaybackRateRangeChange";
    /**
     * Вызывается при изменении скорости воспроизведения видео
     */
    PlayerApiEventName["PlaybackRateChange"] = "PlaybackRateChange";
    /**
     * Вызывается при изменении состояния проигрывания рекламы
     */
    PlayerApiEventName["AdStateChange"] = "AdStateChange";
    /**
     * Вызывается при изменении времени до старта рекламы
     */
    PlayerApiEventName["NextAdRemainingTimeChange"] = "NextAdRemainingTimeChange";
    /**
     * Вызывается перед стартом каждого рекламного ролика из блока рекламы.
     */
    PlayerApiEventName["BeforeAdPodStart"] = "BeforeAdPodStart";
    /**
     * Вызывается при старте каждого рекламного ролика из блока рекламы.
     */
    PlayerApiEventName["AdPodStart"] = "AdPodStart";
    /**
     * Вызывается при пропуске рекламного ролика из блока рекламы.
     */
    PlayerApiEventName["AdPodSkip"] = "AdPodSkip";
    /**
     * Вызывается при завершении каждого рекламного ролика из блока рекламы.
     */
    PlayerApiEventName["AdPodEnd"] = "AdPodEnd";
    /**
     * Вызывается при смене состояния видимости кнопки пропустить в рекламе.
     */
    PlayerApiEventName["AdSkippableStateChange"] = "AdSkippableStateChange";
    /**
     * Вызывается при изменении возможности установки громкости рекламы.
     */
    PlayerApiEventName["AdVolumeAvailabilityStateChange"] = "AdVolumeAvailabilityStateChange";
    /**
     * Вызывается при смене состояния видимости кнопки close/abuse в рекламе.
     */
    PlayerApiEventName["AdPodCloseStateChange"] = "AdPodCloseStateChange";
    /**
     * Вызывается при смене длительности пода рекламы.
     */
    PlayerApiEventName["AdPodDurationChange"] = "AdPodDurationChange";
    /**
     * Вызывается при смене текущего времени пода рекламы.
     */
    PlayerApiEventName["AdPodCurrentTimeChange"] = "AdPodCurrentTimeChange";
    /**
     * Вызывается при изменении времени до возможности пропустить рекламу.
     */
    PlayerApiEventName["AdPodTimeToSkipChange"] = "AdPodTimeToSkipChange";
    /**
     * Вызывается при взаимодействии пользователя с ad (mouse events, touche events, focus events)
     */
    PlayerApiEventName["AdInteraction"] = "AdInteraction";
    /**
     * Вызывается при изменении буферизованной области
     */
    PlayerApiEventName["BufferedRangesChange"] = "BufferedRangesChange";
    /**
     * Вызывается при изменении мета-информации о превью в потоке
     */
    PlayerApiEventName["TileMetaInfoChange"] = "TileMetaInfoChange";
    /**
     * Вызывается при изменении URL с мета-информацией о превью в потоке
     */
    PlayerApiEventName["TileMetaInfoUrlChange"] = "TileMetaInfoUrlChange";
    /**
     * Изменился статус сети.
     */
    PlayerApiEventName["NetworkStatusChange"] = "NetworkStatusChange";
    /**
     * Плеер осуществляет процесс recover воспроизведения.
     */
    PlayerApiEventName["RecoverStart"] = "RecoverStart";
    /**
     * Изменение качества соединения с сетью
     */
    PlayerApiEventName["ConnectionQualityChange"] = "ConnectionQualityChange";
    /**
     * Изменение текущей drm-системы.
     */
    PlayerApiEventName["DrmSystemChange"] = "DrmSystemChange";
    /**
     * Реклама загружена
     */
    PlayerApiEventName["AdLoaded"] = "AdLoaded";
    /**
     * Ошибка работы рекламного креатива, при которой плеер должен прекратить показ данной рекламы и вернуться к воспроизведению контента
     */
    PlayerApiEventName["AdError"] = "AdError";
    /**
     * Клик по рекламе
     */
    PlayerApiEventName["AdPodClick"] = "AdPodClick";
    /**
     * В мета-данных обнаружен InrollFrame (вызывается если не передан adConfig)
     */
    PlayerApiEventName["InrollFrame"] = "InrollFrame";
    /**
     * Изменение статуса ugc-трансляции
     */
    PlayerApiEventName["UgcLiveStatusChange"] = "UgcLiveStatusChange";
    /**
     * Отрисован кадр видео. В Firefox работает через обычный интервал (около 30 в секунду).
     * Из-за частоты срабатывания может замедлять работу приложения, поэтому НЕ РЕКОМЕНДУЕТСЯ
     * подписываться на это события без серьезной необходимости.
     */
    PlayerApiEventName["FrameRendered"] = "FrameRendered";
})(PlayerApiEventName || (exports.PlayerApiEventName = PlayerApiEventName = {}));
